module.exports = {
    home: {
        title: 'ボーナス、プレゼント、クーポン'
    },
    landing: {
        warranty: '24ヶ月保証'
    },
    warranty: {
        title: '注：私たちはお客様の個人情報を誰とも共有しません。',
        name: 'お客様の名前：',
        nameAlert: '名前は32文字を超えてはなりません',
        email: 'メール： ',
        emailAlert: 'メールアドレスは32文字を超えてはなりません',
        emailAlert2: '有効なメールアドレスを入力してください',
        order: 'Amazonの注文番号：',
        orderAlert: '正しいAmazon注文番号を入力してください',
        market: '購入のサイト：',
        interested: '無料商品の体験に興味がありますか？',
        submit: '投稿する'
    },
    finished: {
        title: '保証申請書を受け取りました、ありがとうございます'
    },
    alert: {
        90001: 'Amazonの注文番号が存在しません。正しいAmazonの注文番号を入力してください。',
        90002: '注文番号の正しい購入プラットフォームを選択してください。',
        90003: 'この注文番号の保証はすでに有効になっており、再送信する必要はありません。'
    }
}